import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Package, Users, UserCog, Wallet } from 'lucide-react';
import Sidebar from '../components/Sidebar';
import TopBar from '../components/TopBar';
import SummaryCard from '../components/SummaryCard';
import LoadingSpinner from '../components/LoadingSpinner';
import { getDashboardSummary } from '../api/dashboardApi';
import { isAdmin } from '../utils/auth';
import { useToast } from '../context/ToastContext';

function Dashboard() {
  const { t } = useTranslation();
  const { showToast } = useToast();

  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchSummary() {
      try {
        const result = await getDashboardSummary();
        if (result.success) {
          setSummary(result);
        } else {
          showToast('error', result.message || 'Failed to load dashboard.');
        }
      } catch (err) {
        showToast('error', 'Could not connect to server.');
      } finally {
        setLoading(false);
      }
    }
    fetchSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div style={{ flex: 1 }}>
        <TopBar title={t('nav.dashboard')} />

        <div style={{ padding: 24 }}>
          {loading && <LoadingSpinner fullScreen />}

          {!loading && summary && (
            <div style={styles.grid}>
              <SummaryCard
                icon={Package}
                iconColor="#2563eb"
                iconBg="#eff6ff"
                label="Active Loads"
                value={summary.loads.active}
                subtext={`${summary.loads.total} total`}
                to="/loads"
              />

              <SummaryCard
                icon={Users}
                iconColor="#059669"
                iconBg="#d1fae5"
                label="Active Drivers"
                value={summary.drivers.active}
                subtext={`${summary.drivers.total} total`}
                to="/drivers"
              />

              {isAdmin() && (
                <SummaryCard
                  icon={UserCog}
                  iconColor="#7c3aed"
                  iconBg="#ede9fe"
                  label="Dispatchers"
                  value={summary.dispatchers.total}
                  to="/dispatchers"
                />
              )}

              <SummaryCard
                icon={Wallet}
                iconColor="#d97706"
                iconBg="#fef3c7"
                label="Unpaid Payments"
                value={summary.payments.unpaid_count}
                subtext={`${Number(summary.payments.unpaid_sum).toLocaleString()} total owed`}
                to="/payments"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: 16,
  },
};

export default Dashboard;